/**
 * Load polyfill for Intl (iOS9 support)
 * @param callback
 */
module.exports = function(callback) {
    if (!global.Intl) {
        require.ensure([
            'intl',
        ], function (require) {
            require('intl');
            callback()
        });
    } else {
        callback()
    }
};